import React from 'react'
import type { ContainerWithContextMenuProps } from '../ContainerWithContextMenu'
import { ContainerWithContextMenu } from '../ContainerWithContextMenu'

export type CellWithContextMenuProps = ContainerWithContextMenuProps
export const CellWithContextMenu = ({ as: _as, ...props }: CellWithContextMenuProps) => {
  return <ContainerWithContextMenu as="td" {...props} />
}
